import { Component, Input, OnInit } from '@angular/core';
import { first } from 'rxjs/operators';
import { OwnerReviewService, OwnerReview } from '@app/_components/owner-review';
import { AlertService, AuthenticationService, DataCacheService } from '@app/_services';
import { Router } from '@angular/router';
import { SelectItem, LazyLoadEvent, MessageService } from 'primeng/api';
import { Locations, ListingStatus } from '@app/_helpers/constants';
import { DialogService } from 'primeng/dynamicdialog';
import { OwnerReviewComponent } from '../owner-review/owner-review.component';


@Component({
    selector: 'app-owner-review-list',
    templateUrl: './owner-review-list.component.html',
    styleUrls: ['./owner-review-list.component.css'],
    providers: [DialogService],
    standalone: false
})
export class OwnerReviewListComponent implements OnInit {

	// 0 or 1 of the following Ids may be passed.  If passed, filter on Id.
	@Input() shortTermRentalId: any;
	@Input() activityId: any;
	@Input() propertyCode: any;
	@Input() reservationId: any;

	datasource: OwnerReview[];
	ownerReview: OwnerReview;
	ownerReviews: OwnerReview[] = [];
	columns: any[];
	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	userStatusOptions: SelectItem[];
	showPaginator = false;

	statuses = [
		{ name: 'Draft', value: 1 },
		{ name: 'New', value: 2 },
		{ name: 'Approved', value: 3 },
		{ name: 'Rejected', value: 4 },
	];



	constructor(
		private authenticationService: AuthenticationService,
		private ownerReviewService: OwnerReviewService,
		private dataCacheService: DataCacheService,
		private alertService: AlertService,
		private messageService: MessageService,
		private router: Router,
		public dialogService: DialogService
	) { }


	ngOnInit() { }

	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);



			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-test-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'reviewDate', order: -1 });
			}
			
			if(this.activityId)
			{
				// show only activities that are assigned to this activityId
				let activityIdFilter = { 'activityId': { 'value': this.activityId, 'matchMode': 'in' } };
				Object.assign(event.filters, activityIdFilter);
			}
			
			if(this.shortTermRentalId)
			{
				// show only shortTermRentals that are assigned to this shortTermRentalIdFilter
				let shortTermRentalIdFilter = { 'shortTermRentalId': { 'value': this.shortTermRentalId, 'matchMode': 'in' } };
				Object.assign(event.filters, shortTermRentalIdFilter);
			}
			
			if (this.reservationId) {
				// show only reservations that are assigned to this reservationId
				let reservationIdFilter = { 'reservationId': { 'value': this.reservationId, 'matchMode': 'in' } };
				Object.assign(event.filters, reservationIdFilter);
			}
			
			if(this.propertyCode)
			{
				// show only shortTermRentals that are assigned to this propertyCodeFilter
				let propertyCodeFilter = { 'shortTermRentalVO.propertyCode': { 'value': this.propertyCode, 'matchMode': 'in' } };
				Object.assign(event.filters, propertyCodeFilter);
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.ownerReviewService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					res => {
						this.datasource = res.data.ownerReviews;
						this.recordTotal = res.page.recordTotal;
						this.ownerReviews = res.data.ownerReviews;
						if(this.ownerReviews.length < event.rows){
							this.showPaginator = false;
						}else{
							this.showPaginator = true;
						}
						console.log(JSON.stringify(res.page))
					},
					err => {
						console.log('ownerReviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.ownerReviews = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}
	onRowSelect(event) {

		const ref = this.dialogService.open(OwnerReviewComponent, {
			data: {
				ownerReview: event.data,
			},
			header: 'Owner Review',
			width: '80%',
			closeOnEscape: true
		});

		ref.onClose.subscribe((ownerReview: OwnerReview) => {
			if (ownerReview) {
				if (ownerReview.action === 'UPDATED') {
					var foundIndex = this.ownerReviews.findIndex(x => x.ownerReviewId == ownerReview.ownerReviewId);
					this.ownerReviews[foundIndex] = ownerReview;
				}

				if (ownerReview.action === 'DELETED') {
					var foundIndex = this.ownerReviews.findIndex(x => x.ownerReviewId == ownerReview.ownerReviewId);
					this.ownerReviews.splice(foundIndex, 1);
					this.messageService.add({ severity: 'info', summary: 'Success', detail: 'OwnerReview ' + ownerReview.ownerReviewId + ' Deleted.', sticky: false });
				}
			}
		});
	}



	onNewOwnerReviewButtonClick() {
		const ref = this.dialogService.open(OwnerReviewComponent, {
			data: {
				reservationId: this.reservationId
			},
			header: 'Owner Review',
			width: '80%',
			closeOnEscape: true
		});

		ref.onClose.subscribe((ownerReview: OwnerReview) => {
			if (ownerReview) {

				if (ownerReview.action === 'ADDED') {
					this.ownerReviews.unshift(ownerReview);
				}
			}
		});
	}
	get Statuses() {
		return this.statuses;
	}

	getStatusName(ownerReview: any) {
		const status = this.statuses.find(e => e.value === ownerReview.status);
		return status.name;
	}
	
	reloadPage() {
		window.location.reload();
	}
}